import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import { RaModule } from 'resources/RaModule';
import { ResourceName, ResourceIntent } from 'shared/enums';

import { MembershipDisplayEdit } from './components/MemberhsipDisplayEdit.component';
import { MembershipDisplayList } from './pages/MembershipDisplayList.component';
import { MembershipDisplayShow } from './pages/MembershipDisplayShow.component';
import { ResourceComponentProps } from 'react-admin';

const allowExtendedOfferInfo = false;

export const membershipDisplayModule = RaModule.fromResourceProps({
  name: ResourceName.MEMBERSHIP_DISPLAY,
  options: { label: 'Offers' },
  list: (props: ResourceComponentProps) =>
    MembershipDisplayList({ ...props, allowExtendedOfferInfo }),
  show: allowExtendedOfferInfo ? MembershipDisplayShow : undefined,
  edit: allowExtendedOfferInfo ? MembershipDisplayEdit : undefined,
  intent: ResourceIntent.ROUTE,
  icon: ShoppingBagIcon
});
